<template>
  <div>
    <div v-if="reports && reports.length > 0">
      <div class="sidemenu-mask-dropdown" @click="() => (isOpen = !isOpen)" :id="'reports-' + year + item.id" :type="item.id">
        <div class="tooltip-hover" :open="undefined" :title="year">
          <i :class="['status-icon fa fa-chevron-right', isOpen ? 'open' : 'closed']"></i>
          <i v-if="!isOpen" class="fa fa-folder"></i>
          <i v-if="isOpen" class="fa fa-folder-open"></i>
          {{ year }}
        </div>
      </div>
      <div class="sidemenu-mask-dropdown-list" :data-controlled-by="'reports-' + year + item.id" :open="isOpen || undefined" :level="getNextLevel() + 1">
        <div v-for="report in sortByNameDesc(reports)" :key="report.Id" v-if="reports && reports.length > 0">
          <spin-loader v-if="isLoading && selectedReportId === report.id" />
          <div
            v-else
            class="sidemenu-mask-item"
            @click.stop="
              () => {
                selectedReportId = report.id
                isLoading = true
                getReport(report).then(() => {
                  isLoading = false
                })
              }
            "
            :report="report.id"
            :style="padding"
          >
            <div class="tooltip-hover" :open="undefined" :title="report.displayName">
              <i class="fas fa-file"></i>
              {{ report.displayName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, inject } from 'vue'
import _ from 'underscore'

const props = defineProps({
  item: Object,
  year: String,
  reports: Array || Object,
  level: Number,
  open: Boolean,
})

const isOpen = ref(false)
const selectedReportId = ref(null)
const isLoading = ref(false)

watch(
  () => props.open,
  (isOpenProp) => {
    if (!isOpenProp) {
      isOpen.value = false
    }
  }
)

const isIE = computed(() => {
  var ua = navigator.userAgent
  return ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
})

const padding = computed(() => {
  if (!isIE.value) {
    return { paddingLeft: `calc(${getNextLevel() * 1.4}rem + 20px)` }
  }

  return {}
})

function sortByNameDesc(reports) {
  let nameParsedReports = []

  reports?.map(function (report) {
    report.name = report.displayName
    nameParsedReports.push(report)
  })

  let duplicateFree = []
  let ids = []

  nameParsedReports.filter((_report) => {
    if (!ids.includes(_report.id)) {
      duplicateFree.push(_report)
      ids.push(_report.id)
    }
  })

  return _.sortBy(duplicateFree, 'name').reverse()
}

function getNextLevel() {
  return props.level + 1
}

const getReport = inject('getReport')
</script>
